import { useHistory, useParams } from "react-router-dom"
import { MembershipDetails } from "./components/details/MembershipDetails"
import { useEffect, useState } from "react";
import { HelpSections } from "./consts/HelpSections";
import { HelpCenterSectionModel } from "./models/HelpCenterSectionModel";

export const HelpCenterDetails = () => {
    const history = useHistory();
    const { id } = useParams<{ id: string; }>();
    const [section, setSection] = useState<HelpCenterSectionModel | null>(null);

    useEffect(() => {
        if(id) {
            const _section = HelpSections.find(h => h.id === Number(id));
            if(!_section)
                return history.replace('/help-center');
            return setSection(_section);
        }
        return history.replace('/help-center');
    }, [id]);


    return (
        <>
            { section && section.detail }
        </>
    )
}